import api from './api';
import type { PlantKiln, PlantKilnFormData, HydraCollection } from '../types/entities';

// Phase 28 (D-05): CRUD-Client fuer die neue Stammdaten-Ressource. Muster 1:1 von plantsApi.ts
// uebernommen. Der Pfad ist gegen `debug:router` geprueft (Plan 28-02, Task 3), nicht geraten.
// Exportiert (Plan 28-06): rotaryKilnPayload.ts baut daraus die Schreib-IRI fuer eingebettete
// PlantKiln-Referenzen, die selbst keine '@id' tragen (Altbestand vor Phase 28).
export const BASE_PATH = '/api/plant_kilns';

export const plantKilnsApi = {
  getAll: async (): Promise<PlantKiln[]> => {
    const response = await api.get<HydraCollection<PlantKiln> | PlantKiln[]>(BASE_PATH);
    // Handle both JSON-LD (hydra) and plain JSON formats
    if (Array.isArray(response.data)) {
      return response.data;
    }
    return response.data['hydra:member'] ?? [];
  },

  // Serverseitiger Werksfilter (Projektregel: filtern statt eine Seite laden und im Frontend
  // nachfiltern) -- ApiFilter(SearchFilter, properties: ['plant' => 'exact']) auf PlantKiln.
  //
  // `allowsOwnMeasurements` (Phase 35, additiv): die Importkaskade fragt damit nach den Oefen
  // OHNE eigenes Anlegerecht -- an genau denen misst der VDZ. Ohne die Angabe verhaelt sich der
  // Aufruf wie bisher.
  getByPlant: async (
    plantId: number,
    options: { allowsOwnMeasurements?: boolean } = {}
  ): Promise<PlantKiln[]> => {
    const params = new URLSearchParams({ plant: String(plantId) });
    if (options.allowsOwnMeasurements !== undefined) {
      params.set('allowsOwnMeasurements', String(options.allowsOwnMeasurements));
    }
    const response = await api.get<HydraCollection<PlantKiln> | PlantKiln[]>(
      `${BASE_PATH}?${params.toString()}`
    );
    if (Array.isArray(response.data)) {
      return response.data;
    }
    return response.data['hydra:member'] ?? [];
  },

  getOne: async (id: number): Promise<PlantKiln> => {
    const response = await api.get<PlantKiln>(`${BASE_PATH}/${id}`);
    return response.data;
  },

  create: async (data: PlantKilnFormData): Promise<PlantKiln> => {
    const response = await api.post<PlantKiln>(BASE_PATH, data);
    return response.data;
  },

  update: async (id: number, data: Partial<PlantKilnFormData>): Promise<PlantKiln> => {
    const response = await api.patch<PlantKiln>(`${BASE_PATH}/${id}`, data, {
      headers: { 'Content-Type': 'application/merge-patch+json' },
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_PATH}/${id}`);
  },
};
